import { combineReducers } from "@reduxjs/toolkit";
import { experiencesApi, spreedlyCredentialsApi } from "@capone/common";
import { userApi } from "@capone/common";
import { reducer as experiencesRewards } from "../modules/rewards/reducer";
import { reducer as experiencesSearch } from "../modules/search/reducer";
import { reducer as experiencesAvailability } from "../modules/availability/reducer";
import { reducer as experiencesTravelWallet } from "../modules/travel-wallet/reducer";
import { reducer as experiencesShop } from "../modules/shop/reducer";

export const rootReducer = combineReducers({
  experiencesRewards,
  experiencesSearch,
  experiencesAvailability,
  experiencesTravelWallet,
  experiencesShop,
  [experiencesApi.reducerPath]: experiencesApi.reducer,
  [spreedlyCredentialsApi.reducerPath]: spreedlyCredentialsApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
});
